import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "stages-rdv-text-filter",
	templateUrl: "./text-filter.component.html",
})
export class TextFilterComponent {
	@Input()
	identifier!: string;

	@Input()
	activeFilters: Map<string, string> = new Map<string, string>();

	@Input()
	placeholder: string = "start.typing";

	@Input()
	labelKey?: string;

	@Output()
	readonly keyUpFired = new EventEmitter<string>();

	onFilterKeyUp(value: string): void {
		this.keyUpFired.emit(value);
	}
}
